import auth from '@/plugins/auth'

import { getRouters } from '@/api/upms'
import router, { constantRoutes, dynamicRoutes } from '@/router'
import Layout from '@/layout/index'
import InnerLink from '@/layout/components/InnerLink'

// 匹配views里面所有的.vue文件
const views = import.meta.glob('@/views/**/*.vue') // 拿到所有组件的按需加载函数，需要时执行
console.log('viewsviews==',views)

const usePermissionStore = defineStore(
  'permission',
  {
    state: () => ({
      routes: [],
      addRoutes: [],
      defaultRoutes: [],
      topbarRouters: [],
      sidebarRouters: []
    }),
    actions: {
      setRoutes(routes) {
        this.addRoutes = routes
        this.routes = constantRoutes.concat(routes)
      },
      setDefaultRoutes(routes) {
        this.defaultRoutes = constantRoutes.concat(routes)
      },
      setTopbarRoutes(routes) {
        this.topbarRouters = routes
      },
      setSidebarRouters(routes) {
        // console.log(routes)
        this.sidebarRouters = routes
      },
      generateRoutes(roles) {
        return new Promise(resolve => {
          // 向后端请求路由数据
          getRouters().then(res => {
            const sdata = JSON.parse(JSON.stringify(res.data))
            const rdata = JSON.parse(JSON.stringify(res.data))
            const defaultData = JSON.parse(JSON.stringify(res.data))
            const sidebarRoutes = filterAsyncRouter(sdata, false, false)
            const rewriteRoutes = filterAsyncRouter(rdata, false, true)
            const defaultRoutes = filterAsyncRouter(defaultData, false, false)
            const asyncRoutes = filterDynamicRoutes(dynamicRoutes)
            asyncRoutes.forEach(route => { router.addRoute(route) })
            this.setRoutes(rewriteRoutes)
            this.setSidebarRouters(constantRoutes.concat(sidebarRoutes))
            this.setDefaultRoutes(sidebarRoutes)
            this.setTopbarRoutes(defaultRoutes)
            const indexPath = getIndexRouter(JSON.parse(JSON.stringify(sidebarRoutes)))
            addIndexRouter(indexPath)
            resolve(rewriteRoutes)
          })
        })
      }
    }
  })
function filterAsyncRouter(asyncRouterMap, lastRouter = false, type = false) {
  return asyncRouterMap.filter(route => {
    if (type && route.children) {
      route.children = flattenTree(route.children, route.path)
    }
    const meta = route.meta
    if (meta) {
      for (let key in meta) {
        const value = meta[key]
        if (value === '1') {
          meta[key] = true
        } else if (value === '0') {
          meta[key] = false
        }
      }
    }
    if (route.components) {
      // Layout ParentView 组件特殊处理
      if (route.type === '1') {
        if (!lastRouter) {
          route.component = Layout
        } else {
          route.component = loadView(route)
        }
        // route.component = ParentView
      } else if (route.type === '2' && meta.isLink) {
        route.component = InnerLink
        const url = route.components[route.name]
        meta['url'] = url.startsWith('http') ? url : `http://${url}`
      } else if (route.type === '2') {
        const componentPath = route.components[route.name] || ''
        // const componentMatched = componentPath.split('/')
        // const componentName = componentMatched[componentMatched.length - 1]
        route.component = loadView(route)
        meta['viewName'] = componentPath;
      }
      delete route.components
    }

    if (route.children != null && route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children, route, type)
    } else {
      delete route['children']
      delete route['redirect']
    }
    return true
  })
}

//路由扁平化
function flattenTree(tree, pPath) {
  let result = [];
  function traverse(node, lastNode = false) {
    result.push(node); // 将当前节点的名称添加到结果数组中
    if (node.children && node.children.length > 0) {
      if (node.components['default'] && !lastNode) {
        node.children.forEach(child => {
          child.path = node.path + '/' + child.path
          if (child.hidden) {
            child['extendPath'] = node.extendPath;
            child.meta['activeMenu'] = node.extendPath;
          } else {
            child['extendPath'] = node.extendPath + '/' + child.path
          }
          traverse(child, lastNode); // 递归遍历子节点
        });

        node.children = undefined
        return
      }
    }
    if (lastNode) {
      node.path = lastNode.path + '/' + node.path
    }
  }
  tree.forEach(node => {
    node['extendPath'] = pPath + '/' + node.path;
    traverse(node);
  })
  return result;
}

//获取首页
function getIndexRouter(routes, lastRouter) {
  for (let el of routes) {
    if (lastRouter) {
      el.path = lastRouter.path + '/' + el.path
    }
    if (el.type == '2' && !el.hidden) {
      // console.log('el', el.path)
      return el.path
    }

    if (el.children && el.children.length && !el.hidden) {
      return getIndexRouter(el.children, el)
    }
  }
  return ''
}
//添加默认首页路由
function addIndexRouter(redirect) {
  router.addRoute({
    path: '/',
    hidden: true,
    redirect
  })
}

// 动态路由遍历，验证是否具备权限
export function filterDynamicRoutes(routes) {
  const res = []
  routes.forEach(route => {
    if (route.permissions) {
      if (auth.hasPermiOr(route.permissions)) {
        res.push(route)
      }
    } else if (route.roles) {
      if (auth.hasRoleOr(route.roles)) {
        res.push(route)
      }
    }
  })
  return res
}

export const loadView = (route) => {
  const view = route.components[route.name]
  // 修改这里的路径拼接方式
  const path = view ? `/src/views/${view}.vue` : null
  if (!path || !views[path]) {
    console.warn(`Route component not found: ${path}`)
    return () => import('@/views/error/404.vue')
  }
  return () => views[path]().then(result => {
    const def = result.default
    def.name = def.__name = view // 修改组件名为 路径 + 文件名，保证组件名唯一，便于 keepalive 缓存
    return result
  })
}

export default usePermissionStore
